import type { ShareSeries, ShareSeriesInput } from 'generated/gql';
import { pick } from 'lodash';

export const mapShareSeriesToShareSeriesInput = (shareSeries: ShareSeries): ShareSeriesInput => ({
  ...pick(shareSeries, ['from', 'to']),
  shareTypeId: shareSeries.shareType.id,
});
